import Component from '../colorz/Component';
import getData from '@utils/html/getData';
import Device from '@utils/html/Device';
import {breakpointsApp} from '../colorz/configClrzApp';

export default class Tabs extends Component {
	onInit(el) {
		this.el = el;
		this.titles = this.el.querySelectorAll('[data-tab-title]');
		this.contents = this.el.querySelectorAll('[data-tab-content]');
	}

	onReady() {
		this.titles.forEach((title) => {
			title.addEventListener('click', () => {
				this.idTitle = getData(title, 'id');

				this.isMobile = Device.width < breakpointsApp.desktop;

				if (title.classList.contains('is-active')) {
					if (this.isMobile) {
						title.classList.remove('is-active');
						this.el
							.querySelector('[data-content=' + this.idTitle + ']')
							.classList.remove('is-active');
					}
				} else {
					this.switchTab(this.idTitle, title);
				}
			});
		});
	}

	switchTab(id, title) {
		this.contents.forEach((content) => {
			this.idContent = getData(content, 'content');
			this.colorText = getData(content, 'color-text');
			this.colorBg = getData(content, 'color-bg');

			if (id == this.idContent) {
				if (this.el.querySelector('[data-tab-title].is-active')) {
					this.el
						.querySelector('[data-tab-title].is-active')
						.classList.remove('is-active');
				}

				if (this.el.querySelector('[data-tab-content].is-active')) {
					this.el
						.querySelector('[data-tab-content].is-active')
						.classList.remove('is-active');
				}

				content.classList.add('is-active');
				title.classList.add('is-active');
				this.el.style.setProperty('--color-text', this.colorText);
				this.el.style.setProperty('--color-bg', this.colorBg);

				if (this.colorBg == '#fff' || this.colorBg == '#ffffff') {
					this.el.classList.remove('with-padding');
				} else {
					this.el.classList.add('with-padding');
				}
			}
		});
	}
}
